var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmPatternMapL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-pattern-map-dm-cls-1 {\n        fill: #c1c1c1;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-1, .dummy-widget-pattern-map-dm-cls-2, .dummy-widget-pattern-map-dm-cls-3, .dummy-widget-pattern-map-dm-cls-4, .dummy-widget-pattern-map-dm-cls-5, .dummy-widget-pattern-map-dm-cls-6, .dummy-widget-pattern-map-dm-cls-7, .dummy-widget-pattern-map-dm-cls-8, .dummy-widget-pattern-map-dm-cls-9 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-10 {\n        clip-path: url(#dummy-widget-pattern-map-dm-clippath);\n      }\n\n      .dummy-widget-pattern-map-dm-cls-2, .dummy-widget-pattern-map-dm-cls-11 {\n        fill: none;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-3 {\n        fill: #3869b0;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-4 {\n        fill: #e9e9ea;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-11 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-5 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-5, .dummy-widget-pattern-map-dm-cls-8 {\n        fill: #fff;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-12 {\n        clip-path: url(#dummy-widget-pattern-map-dm-clippath-1);\n      }\n\n      .dummy-widget-pattern-map-dm-cls-6 {\n        fill: #e6e6e4;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-7 {\n        fill: #f4f3f3;\n      }\n\n      .dummy-widget-pattern-map-dm-cls-9 {\n        fill: #dadada;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-pattern-map-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-2",
    x: 7,
    y: 7.6,
    width: 157.3,
    height: 155.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-pattern-map-dm-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-2",
    x: 11.2,
    y: 39.1,
    width: 94.7,
    height: 91
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-4",
    d: "M8.4,0h153.4C166.4,0,170.2,3.7,170.2,8.3v153.4c0,4.6-3.7,8.3-8.4,8.3H8.4c-4.6,0-8.4-3.7-8.4-8.3V8.3C0,3.7,3.7,0,8.4,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-pattern-map-dm-cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    d: "M13.9,33.4h143.3c3.8,0,6.8,3,6.8,6.8v89.6c0,3.8-3.1,6.8-6.8,6.8H13.9c-3.8,0-6.8-3-6.8-6.8V40.2c0-3.8,3.1-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-1",
    d: "M157.2,136.8H13.9c-3.9,0-7-3.2-7-7V40.2c0-3.9,3.2-7,7-7h143.3c3.9,0,7,3.2,7,7v89.6c0,3.9-3.2,7-7,7ZM13.9,33.6c-3.6,0-6.6,3-6.6,6.6v89.6c0,3.6,3,6.6,6.6,6.6h143.3c3.6,0,6.6-3,6.6-6.6V40.2c0-3.6-3-6.6-6.6-6.6,0,0-143.3,0-143.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-5",
    d: "M13.9-82.9h143.4c3.8,0,6.8,3,6.8,6.8V13.2c0,3.8-3.1,6.8-6.8,6.8H13.9c-3.8,0-6.8-3-6.8-6.8v-89.3c0-3.8,3.1-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-5",
    d: "M13.9,149.9h143.3c3.8,0,6.8,3,6.8,6.8v86.2c0,3.8-3.1,6.8-6.8,6.8H13.9c-3.8,0-6.8-3-6.8-6.8v-86.2c0-3.8,3.1-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-pattern-map-dm-cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-7",
    d: "M22.1,39.1h126.4c3.8,0,6.8,3,6.8,6.8v74c0,3.8-3.1,6.8-6.8,6.8H22.1c-3.8,0-6.8-3-6.8-6.8V45.9c0-3.8,3.1-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-9",
    x: 15.3,
    y: 95.1,
    width: 140.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 26.7,
    y: 39.1,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 55.8,
    y: 39.1,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 70.9,
    y: 39.1,
    width: 5.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 128.4,
    y: 39.1,
    width: 5.5,
    height: 46.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 56.5,
    y: 68.2,
    width: 34.2,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 27,
    y: 109.6,
    width: 34.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 84.9,
    y: 39.1,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 113.9,
    y: 39.1,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 143,
    y: 39.1,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("line", {
    className: "dummy-widget-pattern-map-dm-cls-11",
    x1: 29.4,
    y1: 102.3,
    x2: 29.4,
    y2: 126.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 55.8,
    y: 102.3,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 84.9,
    y: 102.3,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 113.9,
    y: 102.3,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    x: 143,
    y: 102.3,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    cx: 92.9,
    cy: 102.3,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    cx: 82.2,
    cy: 71.9,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    cx: 27,
    cy: 50.8,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    cx: 26.9,
    cy: 112.2,
    r: 5.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    d: "M28.1,53.7h-1.4v-4.6l-1.4.4v-1.1l2.7-1h.1s0,6.3,0,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    d: "M84.4,74.7h-4.4v-1l2-2.1c.5-.5.8-1,.8-1.3s0-.4-.2-.7-.3-.2-.5-.2-.4,0-.5.3c0,.2-.2.4-.2.7h-1.4c0-.4,0-.8.3-1.1.2-.3.4-.5.8-.8.3-.2.8-.3,1.1-.3.7,0,1.2,0,1.5.4s.5.8.5,1.3,0,.4,0,.8c0,.2-.2.4-.4.8l-1,1-.8,1h2.5v1.1h0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    d: "M28.7,112.7h.7v1.1h-.7v1.3h-1.4v-1.3h-2.4v-.9l2.4-4.1h1.4v3.8h0ZM26,112.7h1.1v-2h0c0,0-1,2-1,2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-8",
    d: "M92,101.7h.7c.5,0,.8-.2.8-.8s0-.3-.2-.5-.3-.2-.5-.2-.3,0-.5.2-.2.2-.2.4h-1.4c0-.3,0-.7.3-.9.2-.2.4-.4.8-.7s.7-.2,1.1-.2c.7,0,1.2,0,1.6.4s.5.8.5,1.3,0,.5-.2.8-.4.4-.8.5c.3,0,.5.3.8.5s.3.5.3.9-.2,1-.7,1.3c-.4.3-1,.5-1.8.5s-.8,0-1.1-.2c-.3,0-.7-.3-.8-.7-.2-.3-.2-.5-.2-1h1.4c0,.2,0,.3.2.5s.3.2.5.2.4,0,.7-.2.2-.3.2-.5c0-.3,0-.5-.2-.7s-.3-.2-.7-.2h-.7v-1.1h0v.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M114.3,42.8h40.2c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-40.2c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,58.1h24.6c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-24.6c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,64.8h20c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-20c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    d: "M115.2,65.4h-1.4v-4.6l-1.4.4v-1.1l2.7-1h0s0,6.3,0,6.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,76.1h24.5c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-24.5c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,82.8h24.5c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-24.5c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    d: "M116.3,84.1h-4.4v-1l2-2.1c.5-.5.8-1,.8-1.3s0-.4-.2-.7-.3-.2-.5-.2-.4,0-.5.3c0,.2-.2.4-.2.7h-1.4c0-.4,0-.8.3-1.1.2-.3.4-.5.8-.8.3-.2.8-.3,1.1-.3.7,0,1.2,0,1.5.4s.5.8.5,1.3,0,.4,0,.8c0,.2-.2.4-.4.8l-1,1-.8,1h2.5v1.1h0-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,94.1h24.6c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-24.6c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M120.5,100.8h18.7c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-18.7c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    d: "M113.2,98.2h.7c.5,0,.8-.2.8-.8s0-.3-.2-.5-.3-.2-.5-.2-.3,0-.5.2-.2.2-.2.4h-1.4c0-.3,0-.7.3-.9.2-.2.4-.4.8-.7s.7-.2,1.1-.2c.7,0,1.2,0,1.6.4s.5.8.5,1.3,0,.5-.2.8-.4.4-.8.5c.3,0,.5.3.8.5s.3.5.3.9-.2,1-.7,1.3c-.4.3-1,.5-1.8.5s-.8,0-1.1-.2c-.3,0-.7-.3-.8-.7-.2-.3-.2-.5-.2-1h1.4c0,.2,0,.3.2.5s.3.2.5.2.4,0,.7-.2.2-.3.2-.5c0-.3,0-.5-.2-.7s-.3-.2-.7-.2h-.7v-1.1h0v.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M121.3,112.1h23.6c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-23.6c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-6",
    d: "M121.3,118.8h8.9c1.2,0,2.1.9,2.1,2.1v.2c0,1.2-.9,2.1-2.1,2.1h-8.9c-1.2,0-2.1-.9-2.1-2.1v-.2c0-1.2.9-2.1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-dm-cls-3",
    d: "M115.8,117.3h.7v1.1h-.7v1.3h-1.4v-1.3h-2.4v-.9l2.4-4.1h1.4v3.8h0ZM113.2,117.3h1.1v-2h0c0,0-1,2-1,2h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmPatternMapL);
export default __webpack_public_path__ + "static/media/dm_pattern_map_l.7d6e24f9.svg";
export { ForwardRef as ReactComponent };